import QuestionItem from "../QuestionItem";
import styles from "./styles.module.css"

import { useState, useEffect, useMemo } from "react";

import { database } from "../../../services/firebase-config";

import { getDocs, collection } from "firebase/firestore";
import QuestionCreateButton from "../QuestionCreateButton";

import DataTable from 'react-data-table-component';

export default function ListQuestions() {

    let count = 0;

    const [questions, setQuestions] = useState([]);
    const questionsCollectionRef = collection(database, 'common_questions');
    const [updateTable, setUpdateTable] = useState(1);



    function updateTableData() {
        setUpdateTable(updateTable + 1);
        console.log('updateFirebaseData');
    }


    useEffect(() => {
        const getQuestions = async () => {
            const data = await getDocs(questionsCollectionRef);
            setQuestions(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
            console.log('getFirebaseData');
        }
        getQuestions();
    }, [updateTable]);


    const columns = [
        {
            name: 'Pergunta',
            selector: row => row.question,
            sortable: true,
        },
        {
            name: 'Resposta',
            selector: row => row.answer,
            sortable: true,
        },
        {
            name: 'Ativo',
            selector: row => row.active,
        },
        {
            name: '  ',
            selector: row => row.options,
            style: {
                justifyContent: 'flex-end'
            }
        },
    ];

    const paginationComponentOptions = {
        rowsPerPageText: 'Perguntas por pagina',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

    const [filterText, setFilterText] = useState('');
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const filteredItems = questions.filter(
        ebook => ebook.question && ebook.question.toLowerCase().includes(filterText.toLowerCase()),
    );

    const data = filteredItems.map((question) => {
        return {
            question: question.question,
            answer: question.answer,
            active: question.deleted ? 'Desativado' : 'Ativado',
            options: <QuestionItem key={question.id} collectionRef={questionsCollectionRef} count={count++} questionData={question} updateTableData={updateTableData} />

        }
    })

    const subHeaderComponentMemo = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText('');
            }
        };

        return (
            <div className={styles.filterTable}>
                <label htmlFor="filtro">Buscar: </label>
                <input id='filtro' name='filtro' placeholder='Pergunta...' onChange={e => setFilterText(e.target.value)} value={filterText} />
            </div>

        );
    }, [filterText, resetPaginationToggle]);



    return (
        <div className={styles.ListContainer}>
            <div className={styles.ControlsContainer}>
                <QuestionCreateButton updateTableData={updateTableData} collectionRef={questionsCollectionRef} />
                {subHeaderComponentMemo}
            </div>
            <DataTable
                title="Perguntas Frequentes"
                pagination
                paginationComponentOptions={paginationComponentOptions}
                noDataComponent="Nenhuma pergunta encontrada"
                columns={columns}
                data={data} />
        </div>
    );
}